// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { fontConfig } from "@awc/XDL/PreStyle/typography";
import { modalButtonsActionStyles, xScreen } from "@awc/XDL/Utilities";
import { defaultShippingAddressStyles } from "@insite/content-library/Widgets/AccountSettings/DefaultShippingAddress";
import { css } from "styled-components";

defaultShippingAddressStyles.gridContainer = {
    gap: 0,
};

defaultShippingAddressStyles.editLink = {
    typographyProps: {
        size: fontConfig.fontSize.small,
        weight: fontConfig.weight.bold,
        css: css`
            line-height: ${fontConfig.lineHeight.singleLineRegular};
        `,
    },
};

defaultShippingAddressStyles.headingGridItem = {
    width: 12,
    css: css`
        align-items: baseline;
        gap: 24px;
        ${xScreen("lte", "xs")} {
            justify-content: space-between;
        }
    `,
};

defaultShippingAddressStyles.headingText = {
    variant: "h4",
    as: "h3",
};

defaultShippingAddressStyles.customerSelectorModalCancelButton = {
    variant: "secondary",
    css: css`
        ${xScreen("lte", "xs")} {
            width: 100%;
        }
    `,
};

defaultShippingAddressStyles.addressInfoDisplayGridItem = {
    width: 12,
    css: css`
        margin-top: 8px;
    `,
};

defaultShippingAddressStyles.customerSelectorModal = {
    cssOverrides: {
        modalContent: css`
            overflow-x: hidden;
        `,
    },
};

defaultShippingAddressStyles.customerSelectorModalButtonsWrapper = {
    ...modalButtonsActionStyles.buttonsGridItem,
};

defaultShippingAddressStyles.customerSelectorModalCancelButton = {
    ...modalButtonsActionStyles.cancelButton,
};
